export default __webpack_public_path__ + "c3da961ef27808aaec54a9197ef9ded3.png";